class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    // Els
    this.els = this.querySelectorAll('[data-announcement]');
    this.countdownEls = this.querySelectorAll('[data-countdown]');
    this.linkEls = this.querySelectorAll('[data-announcement] a');

    // Primary settings
    this.hasFreeShippingBanner = this.dataset.hasFreeShippingBanner;
    this.indexActive = 0;
    this.indexLast = this.els.length - 1;
    this.isFirst = true;
    this.settings = JSON.parse(this.dataset.settings);

    // Secondary settings
    this.hasAutoplay = this.settings.autoplay > 0;
    this.hasCarousel = this.settings.carousel;

    // Events
    if (this.countdownEls.length > 0) this.countdown();
    if (this.hasAutoplay) this.autoplay();
    if (this.hasCarousel) this.nav();
    if (this.hasFreeShippingBanner) this.freeShippingBanner();
    this.close();

    // Listeners
    this.listeners();
  }

  autoplayTimerStart() {
    this.timerIsPaused = false;

    this.timer = setInterval(() => {
      this.els[this.indexActive].classList.replace('active', 'hide');
      this.indexActive = this.indexActive + 1 > this.indexLast ? 0 : this.indexActive + 1;

      requestAnimationFrame(() => {
        this.els[this.indexActive].classList.replace('hide', 'active');
      });
    }, this.settings.autoplay);
  }

  autoplayTimerPause() {
    if (!this.hasAutoplay) return;

    this.timerIsPaused = true;
    clearInterval(this.timer);
  }

  autoplayTimerStop() {
    if (!this.hasAutoplay) return;

    this.timerIsStopped = true;
    clearInterval(this.timer);
  }

  autoplay() {
    this.timer = setTimeout(() => {
      this.classList.remove('announcement--first');
      this.isFirst = false;
    }, this.settings.autoplay - 50);

    this.autoplayTimerStart();
  }

  updateFreeShippingBanner(total) {
    const away = Math.abs(total - window.freeShipping.amount);
    const hasFreeShipping = total >= window.freeShipping.amount;

    document.querySelectorAll('[data-free-shipping-message]').forEach(el => {
      const type = el.dataset.freeShippingMessage;

      if (hasFreeShipping) {
        el.classList[type === 'met' ? 'remove' : 'add']('hide');
      } else {
        el.classList[type === 'met' ? 'add' : 'remove']('hide');
        document.querySelectorAll('[data-announcement-threshold]').forEach(el => el.innerHTML = window.Shopify.formatMoney(away).replace('.00', ''));
      }
    });
  }

  freeShippingBanner() {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      if (event.source === 'product-form') return;
      this.updateFreeShippingBanner(event.cartData.total_price);
    });
  }

  listeners() {
    if (!this.hasAutoplay || this.timerIsStopped) return;

    this.linkEls.forEach(el => {
      el.addEventListener('focus', e => {
        this.autoplayTimerPause();
      });

      el.addEventListener('blur', e => {
        if (!this.timerIsPaused) return;
        this.autoplayTimerStart();
      });
    });
  }

  nav() {
    this.navNext = this.querySelector('[data-nav="next"]');
    this.navPrev = this.querySelector('[data-nav="prev"]');

    [this.navNext, this.navPrev].forEach(el => {
      if (el) {
        el.addEventListener('click', () => {
          if (this.isFirst) this.classList.remove('announcement--first');

          requestAnimationFrame(() => {
            this.autoplayTimerStop();
            this.navUpdate(el.dataset.nav);
            this.isFirst = false;
          });
        });
      }
    })
  }

  close() {
    this.announcementClose = this.querySelector('[data-announcement-close]')
    this.announcementClose.addEventListener('click', () => {
      this.announcementSection = this.announcementClose.closest('section')
      if (this.announcementSection) {
        this.announcementSection.style.display = 'none';
      }

      const hideDurationMinutes = window.announcementHideDuration || 30;
      const hideDurationMs = hideDurationMinutes * 60 * 1000;
      const expiryTime = Date.now() + hideDurationMs;
      const storageData = {
        state: 'hide',
        expiry: expiryTime
      };

      window.sessionStorage.setItem('announcement', JSON.stringify(storageData));
    })
  }

  navUpdate(direction) {
    const nextIndex = this.indexActive + 1 > this.indexLast ? 0 : this.indexActive + 1;
    const prevIndex = this.indexActive - 1 < 0 ? this.indexLast : this.indexActive - 1;
    const newIndex = direction === 'prev' ? prevIndex : nextIndex;
    this.els[this.indexActive].classList.replace('active', 'hide');
    this.els[newIndex].classList.replace('hide', 'active');
    this.indexActive = newIndex;
  }

  /***
  * Countdown Timers
  */
  countdown() {
    this.countdownTimers = [];
    this.countdownEls.forEach((el, index) => {
      const data = JSON.parse(el.dataset.countdown);
      const ends = new Date(data.end).toLocaleString('en-US', { timeZone: data.timezone });
      const starts = new Date(data.start).toLocaleString('en-US', { timeZone: data.timezone });

      this.countdownCreate({
        el,
        ends,
        endDate: data.end ? new Date(ends).getTime() : null,
        startDate: data.start ? new Date(starts).getTime() : null,
        timezone: data.timezone,
      }, index);
    });
  }

  /**
  * Create countdown
  */
  countdownCreate(settings, index) {
    const today = Date.parse(new Date());
    const dateHasPassed = Math.sign(settings.endDate - today) >= 0;

    settings.el.title = `Ends ${settings.ends}`;

    if (settings.endDate && dateHasPassed) {
      this.countdownUpdate(settings, settings.el);
      this.countdownTimers[index] = setInterval(() => this.countdownUpdate(settings, settings.el, index), 1000);
    } else {
      settings.el.innerHTML = `
        <span class="countdown__hours">00h:</span>
        <span class="countdown__minutes">00m:</span>
        <span class="countdown__seconds">00s</span>
      `;
    }
  }

  /**
  * Update Timer
  */
  countdownUpdate(settings, $timer, index) {
    const now = Date.parse(new Date());
    const distance = settings.endDate - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      .toLocaleString(undefined, { minimumIntegerDigits: 2 });
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      .toLocaleString(undefined, { minimumIntegerDigits: 2 });
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      .toLocaleString(undefined, { minimumIntegerDigits: 2 });
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)
      .toLocaleString(undefined, { minimumIntegerDigits: 2 });

    if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
      $timer.innerHTML = `
        <span class="countdown__hours">00h:</span>
        <span class="countdown__minutes">00m:</span>
        <span class="countdown__seconds">00s</span>
      `;
      clearInterval(this.timers[index]);
    } else {
      $timer.innerHTML = `
        ${days < 1 ? '' : `<span class="countdown__days">${days}d:</span>`}
        <span class="countdown__hours">${hours}h:</span>
        <span class="countdown__minutes">${minutes}m</span>
        ${days > 0 ? '' : `:<span class="countdown__seconds">${seconds}s</span>`}
      `;
    }
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
